module.exports = {
    individualData: () => {
        return[
            {
                "HB20": [
                    {
                        "Nombre":"NUEVO HB20"
                    }
                ],
                "HB20S": [
                    {
                        "Nombre":"NUEVO HB20S"
                    }
                ],
                "TUCSON": [
                    {
                        "Nombre":"TUCSON NX4 PREMIUM"
                    },
                    {
                        "Nombre":"TUCSON NX4 ATTRACTION"
                    },
                    {
                        "Nombre":"TUCSON NX4 LIMITED"
                    }
                ],
                "KONA": [
                    {
                        "Nombre":"KONA PREMIUM"
                    },
                    {
                        "Nombre":"KONA LIMITED"
                    }
                ],
                "VENUE": [
                    {
                        "Nombre":"VENUE PREMIUM MT"
                    }
                ],
                "STARIA": [
                    {
                        "Nombre":"STARIA PASAJEROS"
                    }
                ],
            }
        ]
    }
}